'use es6';

import { Set as ImmutableSet } from 'immutable';
import I18n from 'I18n';
import { Promise } from '../../lib/promise';
import { CURRENT_TIME } from '../../constants/magicTypes';
export default ((config, paths = ImmutableSet()) => {
  const currentTime = I18n.moment.portalTz().valueOf();
  return Promise.resolve(paths.reduce((memo, path) => memo.updateIn(['filters', ...path], value => value === CURRENT_TIME ? currentTime : null), config));
});